import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import editGeneratedReportsDialog from '../dialog.editGeneratedReports';
import selectAdvisoryReportTypesDialog from '../dialog.selectAdvisoryReportTypes';
import selectReportTypesDialog from '../dialog.selectReportTypes';
import controller from './select-edit-type-dialog.controller';
import template from './select-edit-type-dialog.html';

class dialogService {
  getOptions($event, { hasAdvisoryServices, customerId, reportPackage, selectedEditTypeId }) {
    return {
      controller,
      controllerAs: 'selectEditTypeDialogVM',
      locals: {
        hasAdvisoryServices,
        customerId,
        reportPackage,
        selectedEditTypeId,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular
  .module('app.components.reports.packageReports.selectEditTypeDialog', [
    alerts,
    amDataService,
    constants,
    docDataService,
    loaderService,
    orgDataService,
    ssDialogService,
    userService,
    editGeneratedReportsDialog,
    selectAdvisoryReportTypesDialog,
    selectReportTypesDialog,
  ])
  .service('selectEditTypeDialog', dialogService).name;
